import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api } from "@/lib/api";

const summary = (p) => `${p.card_limit ? `${p.card_limit.toLocaleString()} cards` : "Unlimited cards"} · ${p.duration_months} mo`;

export default function PlanPicker({ value, onChange }) {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/public/plans").then((r) => setPlans(r.data)).catch(() => {}); }, []);
  if (!plans.length) return null;
  return (
    <div className="space-y-1.5" data-testid="register-plan-picker">
      <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Choose a package</span>
      <div className="grid grid-cols-3 gap-2">
        {plans.map((p, i) => {
          const on = value === p.id;
          return (
            <button type="button" key={p.id} onClick={() => onChange(on ? "" : p.id)} data-testid={`register-plan-${i}`}
              className={`relative text-left rounded-lg border p-2.5 transition-colors ${on ? "bg-amber-500/10" : "border-slate-800 hover:border-slate-600"}`}
              style={on ? { borderColor: p.color } : undefined}>
              {on && <Check size={12} className="absolute top-2 right-2" style={{ color: p.color }} />}
              <p className="text-sm font-bold" style={{ color: p.color }}>{p.name}</p>
              <p className="text-sm font-semibold text-slate-100">{p.price || "—"}</p>
              <p className="text-[10px] text-slate-400 mt-0.5 leading-tight">{summary(p)}</p>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-slate-500">{value ? "Your package starts once the administrator approves your account." : "Optional — you can also discuss a package with the administrator."}</p>
    </div>
  );
}
